<div class="tw-min-h-full tw-h-full">
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form
    [formGroup]="formGroup"
    (submit)="submit()"
    class="tw-p-4 tw-h-full tw-min-h-full"
  >
    <div mat-dialog-title class="matp-dialog-title">
      配送設定{{ updating ? "編集" : "新規登録" }}
    </div>

    <mat-dialog-content class="tw-w-full !tw-pt-2 tw-h-[80%] !tw-min-h-[80%]">
      <div class="tw-flex tw-flex-col tw-gap-8">
        <app-shipment-option-edit
          [formGroup]="formGroup.controls.shipmentOption"
          (deviceSearched)="updateAvailableDeviceList()"
        ></app-shipment-option-edit>
        <mat-divider></mat-divider>
        <app-shipment-device-edit
          [formGroup]="formGroup.controls.shipmentDevice"
          [updating]="updating"
          [deviceSettingList]="deviceSettingList"
          [shipmentDeviceSettings]="shipmentDeviceSettings"
          [loadingDeviceSetting]="loadingDeviceSetting"
          (deviceSettingUpdated)="onUpdateDeviceSetting($event)"
        ></app-shipment-device-edit>
        <mat-divider></mat-divider>
        <app-shipment-route-edit
          [formGroup]="formGroup.controls.shipmentRoute"
          [routeList]="routeList"
          [locationList]="locationList"
        >
        </app-shipment-route-edit>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions
      class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4 tw-h-auto"
    >
      <button
        id="cancel-btn"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="edit-btn"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="submitDisabled"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
